(() => {
  function initialize(root) {
    for (const hub of root.querySelectorAll('[data-review-hub]')) {
      if (hub.dataset.reviewReady) continue;
      const grid = hub.querySelector('[data-review-grid]');
      const cards = [...grid.querySelectorAll('[data-review-source]')];
      cards.sort((a, b) => b.dataset.reviewDate.localeCompare(a.dataset.reviewDate));
      for (const card of cards) grid.append(card);
      const filters = hub.querySelector('[data-review-filters]');
      filters.hidden = false;
      filters.addEventListener('click', (event) => {
        const button = event.target.closest('[data-review-filter]');
        if (!button || !filters.contains(button)) return;
        const source = button.dataset.reviewFilter;
        for (const card of cards) card.hidden = source !== 'all' && card.dataset.reviewSource !== source;
        for (const filter of filters.querySelectorAll('button')) filter.setAttribute('aria-pressed', String(filter === button));
        hub.querySelector('[data-review-count]').textContent = String(cards.filter(card => !card.hidden).length);
      });
      hub.dataset.reviewReady = 'true';
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
